import React, { Component } from 'react';

import { Container, Offcanvas, Row, Col,  Form, Tabs, Tab } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonButton from '../components/CommonButton';

import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';

import InlineUserDataExternalUserWorkHistory from '../inline/InlineUserDataExternalUserWorkHistory';
import InlineUserDataExternalUserSkillsSet from '../inline/InlineUserDataExternalUserSkillsSet';
import InlineUserDataExternalUserTrainingHistory from '../inline/InlineUserDataExternalUserTrainingHistory';

class InputUserDataExternalUser extends Component {

        constructor(props) {
            super(props);
            this.state = {
                selectedDate: new Date(),
                changePassword: false,
                activeTab: 'profile'
            };
        }
        
        handleDateChange = (date) => {
            this.setState({ selectedDate: date });
        }

        handleTabSelect = (key) => { this.setState({ activeTab: key }); };        
        
        componentDidUpdate = async (prevProps) => {
            if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
                await this.prepareInputs();
            }
        }
        
        prepareInputs = async () => {
            const { Action, Inputs, onUpdateState } = this.props;
            const isUpdateMode = Action.Mode === 'update';
        
            const updatedInputs = fn.setRequiredPrimaryKey(
                this.initNewPassword(Inputs, false),
                isUpdateMode
            );
        
            this.setState({ changePassword: false }, () => {
                onUpdateState('Inputs', updatedInputs);
            });
        }
        
        toggleChangePassword = () => {
            const { Inputs, onUpdateState } = this.props;
        
            this.setState(
                prevState => ({ changePassword: !prevState.changePassword }),
                () => {
                    const updatedInputs = this.initNewPassword(Inputs, this.state.changePassword);
                    onUpdateState('Inputs', updatedInputs);
                }
            );
        }
        
        initNewPassword = (Inputs, isRequired) => {
            return {
                ...Inputs,
                new_password: {
                    ...Inputs.new_password,
                    value: '',
                    validator: {
                        ...Inputs.new_password.validator,
                        required: isRequired
                    },
                    error: {
                        ...Inputs.new_password.error,
                        status: null
                    }
                }
            };
        }

        render = () => {
            let props = this.props;

            let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onSetEdit, onPreviewFile, onDeleteFile } = props;

            let { App, Action, Inputs, InputGroup, Masterbase, Operation, UserCookie } = props;

            let { Submit } = Operation;
            
            let { show, mode } = Action.OffCanvas;

            let isLoading = Action.Loading.submit;

            return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width': '100vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => { 
                        this.setState({activeTab: 'profile'});
                        props.onClose(e);
                    }}
                >

                  <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                     <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            <Container fluid className="data-table-container">

                                <Tabs 
                                    defaultActiveKey="profile" 
                                    activeKey={this.state.activeTab}
                                    onSelect={(e) => this.handleTabSelect(e)}
                                    className="mb-3"
                                >

                                    <Tab eventKey="profile" title="โปรไฟล์">
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.fullname)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.fullname}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />                                    
                                            </Col>
                                        </Row> 
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.cardid)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.cardid}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />                                    
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1}>{util.formatLabel(null, Inputs.profile_img)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonFile
                                                    element="Inputs"
                                                    input={Inputs.profile_img}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 

                                                    previewFile={(e) => onPreviewFile(e)} 
                                                    deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                                /> 
                                            </Col>
                                        </Row> 
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.enterprise_id)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.enterprise_id}
                                                    option={{source: 'db', data: Masterbase?.enterprise}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />                                    
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.position_id)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.position_id}
                                                    option={{source: 'db', data: Masterbase?.position}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />                                    
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.email)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.email}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />                                    
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.contact)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.contact}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />                                    
                                            </Col> 
                                        </Row>  
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.register_date)}</Col>
                                            <Col md={2} className="mb-3">
                                                <CustomDatePicker 
                                                    element="Inputs"
                                                    input={Inputs.register_date}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />                                 
                                            </Col> 
                                        </Row> 
                                        <Row>
                                             <Col md={6} className="mb-3"><hr className="hr-custom" /></Col>
                                        </Row>
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.username)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.username}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />                               
                                            </Col> 
                                        </Row>  
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.password)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonInput
                                                    mode={Action.Mode}
                                                    element="Inputs"
                                                    input={Inputs.password}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={Action.Mode === 'new' ? false : true}
                                                    
                                                    onGeneratePassword={(e, element) => onInputChange({target: {name: 'password', value: util.generatePassword()}}, element)}

                                                    toggleChangePassword={(e) => this.toggleChangePassword()}
                                                />                             
                                            </Col> 
                                        </Row>

                                        {this.state.changePassword && (
                                            <Row>
                                                <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.new_password)}</Col>
                                                <Col md={3}>
                                                    <CommonInput
                                                        mode="new"
                                                        element="Inputs"
                                                        input={Inputs.new_password}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                        disabled={false}
                                                        
                                                        onGeneratePassword={(e, element) => onInputChange({target: {name: 'new_password', value: util.generatePassword()}}, element)}
                                                    />
                                                </Col>
                                            </Row>
                                        )}  

                                        {['0', '1'].includes(UserCookie.types) && (
                                            <Row>
                                                <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.status)}</Col>
                                                <Col md={3} className="mb-3">
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.status}
                                                        option={{source: 'options', section: 'status', item: 'external_user'}}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />                                   
                                                </Col>
                                            </Row>   
                                        )}
                                    </Tab>

                                    <Tab eventKey="work-experience" title="ประวัติการทำงาน">
                                        <Row>
                                            <Col md={{ span: 10, offset: 1 }} className="mb-3">
                                                <InlineUserDataExternalUserWorkHistory
                                                    fkId="external_user_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>

                                    <Tab eventKey="training-history" title="ประวัติการฝึกอบรม">
                                       <Row>
                                            <Col md={{ span: 10, offset: 1 }} className="mb-3">
                                                <InlineUserDataExternalUserTrainingHistory
                                                    fkId="external_user_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>
                                        </Row>  
                                    </Tab>

                                    <Tab eventKey="skills-set" title="ทักษะ Skills Set">
                                        <Row>
                                            <Col md={{ span: 10, offset: 1 }} className="mb-3">
                                                <InlineUserDataExternalUserSkillsSet
                                                    fkId="external_user_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>
                                        </Row> 
                                    </Tab>

                                </Tabs>
                            </Container>                          
                            
                        </SimpleBar>

                    </Offcanvas.Body>   

                    { this.state.activeTab === 'profile' && (
                        <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                            <CommonLoadingBar isLoading={isLoading} />

                            <div className="d-flex justify-content-end mt-2">
                                <CommonButton 
                                    task={mode} 
                                    disabled={isLoading ? true : Submit ? false : true}
                                    callback={async (e) => {
                                            let currentId = Inputs.id.value;
                                            await onSubmit(e);
                                            if (Action.Mode === 'update') {
                                                onSetEdit({}, {id: currentId}); 
                                            }
                                            this.handleTabSelect('profile');
                                    }} 
                                />

                                {Action.Mode === 'new' && (
                                    <CommonButton 
                                        task="discard" 
                                        inlineClass="ms-1" 
                                        disabled={isLoading} 
                                        callback={(e) => onDiscardSubmit(false)} 
                                    />
                                )}
                            </div>
                        </div>  
                    )} 

                </Offcanvas>                                 
            )
        }

}

export default InputUserDataExternalUser;